// Libs
import React from 'react';
import Box from '@mui/material/Box';

// Components
import CloseButton from '../../../../Button/CloseButton';
import IconButton from '../../../../Button/IconButton/IconButton';
import Feather from '../../../../Feather';
import Rating from '../../../../Rating';
import SaveForLaterButton from '../SaveForLaterButton';

const showsRatingInReviewOrder = (
  reviewOrderPage,
  isDesktopMode,
  isMobileMode,
  isRatable,
) => reviewOrderPage && (isDesktopMode || isMobileMode) && isRatable;

const getRatingOrSaveForLater = ({
  kitDetailsPage,
  isRatable,
  kit,
  reviewOrderPage,
  isDesktopMode,
  isMobileMode,
  placedOrder,
  product,
  count,
  saveForLater,
  classes,
}) => {
  if (kitDetailsPage && !isRatable) {
    return null;
  }
  if (
    kit ||
    showsRatingInReviewOrder(
      reviewOrderPage,
      isDesktopMode,
      isMobileMode,
      isRatable,
    )
  ) {
    return (
      <Rating
        withTooltip={reviewOrderPage ? !!placedOrder?.id : true}
        product={product}
      />
    );
  }
  if (!reviewOrderPage && isMobileMode) {
    return (
      <SaveForLaterButton
        product={product}
        count={count}
        saveForLater={saveForLater}
        className={classes.saveLater}
      />
    );
  }
  return null;
};

const getDeleteButton = ({
  readOnly,
  placedOrder,
  kit,
  onDeleteKitProduct,
  onDeleteClick,
  removeProductFromKit,
  product,
  classes,
  onDeleteProduct,
}) => {
  if (readOnly || placedOrder?.id) {
    return null;
  }

  if (kit) {
    const onDeleteMyKitProduct = () => {
      if (kit?.products.length === 1) {
        onDeleteClick(kit?.id);
      } else {
        removeProductFromKit(kit?.id, product?.product_id);
      }
    };

    return (
      <CloseButton
        onClose={
          onDeleteKitProduct
            ? () => onDeleteKitProduct(product?.product_id)
            : onDeleteMyKitProduct
        }
        className={classes.removeButton}
        data-testid="kit-product-delete-button"
      />
    );
  }

  if (window.location.pathname?.includes('review-order')) {
    return (
      <CloseButton
        onClose={onDeleteProduct}
        className={classes.removeButton}
        data-testid="order-product-delete-button"
      />
    );
  }

  return (
    <IconButton
      onClick={onDeleteProduct}
      startIcon={<Feather type="delete" />}
      className={classes.infoIconButton}
      data-testid="cart-product-delete-button"
    />
  );
};

const CartCardHeader = ({
  product,
  owner,
  isMobileMode,
  isDesktopMode,
  reviewOrderPage,
  kitDetailsPage,
  kit,
  isRatable,
  placedOrder,
  count,
  saveForLater,
  readOnly,
  onDeleteKitProduct,
  onDeleteClick,
  removeProductFromKit,
  onDeleteProduct,
  pendingApproval,
  classes,
}) => (
  <Box
    position="relative"
    display="flex"
    alignItems="start"
    justifyContent="space-between"
    className={classes.iconsContainer}>
    {!isMobileMode && <div className={classes.label}>{owner}</div>}
    <div className={classes.buttons}>
      {getRatingOrSaveForLater({
        kitDetailsPage,
        isRatable,
        kit,
        reviewOrderPage,
        isDesktopMode,
        isMobileMode,
        placedOrder,
        product,
        count,
        saveForLater,
        classes,
      })}
      {getDeleteButton({
        readOnly,
        placedOrder,
        kit,
        onDeleteKitProduct,
        onDeleteClick,
        removeProductFromKit,
        product,
        classes,
        onDeleteProduct,
      })}
    </div>
    {placedOrder?.id && isDesktopMode && pendingApproval && (
      <div className={classes.approvalInfo}>Pending Approval</div>
    )}
  </Box>
);

export default CartCardHeader;
